import React, { Component } from "react";
import styles from "./Popup.module.scss";
import Wrapper from "../../hoc/Wrapper/Wrapper";
import { withRouter } from "react-router-dom";
import Button from "../UI/Button/Button";
import copy from "../../assets/copy/copy.json"
import { addDays, addWeeks, set, getDay, format, startOfWeek } from "date-fns";
import { Requests } from "../../api/IdentityServerRequests/Requests";
import Prompt from "../UI/Popup/Prompt";
import { copyWeek } from "./CopyPaste";

var classNames = require("classnames");

const scheduler = window.scheduler;

class AvailabilityTemplateModal extends Component {
  constructor(props) {
    super(props);
    this.Requests = new Requests();
    this.state = {
      showPopup: false,
      templateList: [],
      templateName: '',
      selectedTemplate: null,
      selectedTemplateName: null
    };
    this.templateToApply = null;
  }

  saveAvailabilityAsTemplate = () => {
    // transform events in view to match payload schema
    const AvailabilityTemplateItems = copyWeek();
    const templateToSave = {
      TemplateName: this.state.templateName,
      Agency: this.props.selectedAgency,
      AvailabilityTemplateItems,
    }
    const API_ENDPOINT = this.Requests.postUserTemplate
    // API call to save
    this.Requests.callAPI(API_ENDPOINT, templateToSave).then((data) => {
      if (data?.status === 200) {
        this.loadSavedTemplates()
      }
    })
  }

  loadSavedTemplates = () => {
    const API_ENDPOINT = this.Requests.getUserTemplates
    this.Requests.callAPI(API_ENDPOINT).then((data) => {
      if (data?.status === 200) {
        let templateList = data.data.filter(e => e.Agency === this.props.selectedAgency)
        this.setState({
          templateList: templateList
        })
      }
    })
  }

  componentDidMount() {
    this.loadSavedTemplates();
  }

  componentWillUnmount() {
    this.setState({ showPopup: false });
  }

  applyTemplate = (template) => {
    this.templateToApply = template;
    const viewStart = scheduler.getState().min_date;
    const viewEnd = scheduler.getState().max_date;
    const eventsInView = scheduler.getEvents(viewStart, viewEnd)
    if (eventsInView.length > 0) {
      // You are going to overwrite your week
      this.setState({ overwritePromptShowing: true })
    } else {
      this.props.applyClick(template)
    }
  }

  handleApplyClick = () => {
    const API_ENDPOINT = this.Requests.getUserTemplate

    if (this.state.selectedTemplate) {
      // request that template from API
      this.Requests.callAPI(API_ENDPOINT, this.state.selectedTemplate).then((data) => {
        if (data?.status === 200) {
          this.applyTemplate(data.data.AvailabilityTemplateItems)
        }
      })
    }
  }

  deleteTemplate = () => {
    const API_ENDPOINT = this.Requests.deleteUserTemplate
    if (this.state.selectedTemplate) {
      this.Requests.callAPI(API_ENDPOINT, this.state.selectedTemplate).then((data) => {
        if (data?.status === 200) {
          this.loadSavedTemplates();
        }
      })
    }
  }

  handleDeleteClick = () => {
    if (this.state.selectedTemplate) {
      this.setState({ deletePromptShowing: true })
    }
  }

  handleTemplateClick = (selection) => {
    this.setState({ selectedTemplate: selection.TemplateId, selectedTemplateName: selection.TemplateName })
  }

  render() {
    if (this.props.isVisible) {
      document.body.classList.add("popup-mode");
    } else {
      document.body.classList.remove("popup-mode");
    }

    let CloseAlertControls = classNames(
      "tileBg2 " + styles.closeAlertControls,
      this.props.className,
      {
        [styles.visible]: this.props.isVisible,
      }
    );

    let DarkMask = classNames(styles.darkMask, this.props.className, {
      [styles.visible]: this.props.isVisible,
    });
    const deletePromptButtons = [
      <Button
        key="back-button-delete"
        label="Back"
        buttonClick={() => this.setState({ deletePromptShowing: false })}
        content="Back"
        variant="btn_secondary"
        styles="neutralGrey"
      ></Button>,
      <Button
        key="confirm-button-delete"
        label="Confirm"
        buttonClick={() => this.setState({ deletePromptShowing: false }, this.deleteTemplate)}
        content="Confirm"
        variant="btn_secondary"
        styles="neutralGrey"
      ></Button>
    ]
    const overwritePromptButtons = [
      <Button
        label="Back"
        key="back-button-overwrite"
        buttonClick={() => this.setState({ overwritePromptShowing: false })}
        content="Back"
        variant="btn_secondary"
        styles="neutralGrey"
      ></Button>,
      <Button
        label="Confirm"
        key="confirm-button-overwrite"
        buttonClick={() => this.setState({ overwritePromptShowing: false }, () => {
          this.props.applyClick(this.templateToApply)
        })}
        content="Confirm"
        variant="btn_secondary"
        styles="neutralGrey"
      ></Button>
    ]

    return (
      <Wrapper>
        {this.state.overwritePromptShowing &&
          <Prompt
            isVisible={this.state.overwritePromptShowing}
            titleText="Please note"
            subtitleText="Note that this will override any availability you had previously entered into this week"
            buttons={overwritePromptButtons}
            onClose={() => this.setState({ overwritePromptShowing: false })}
          />
        }
        {
          this.state.deletePromptShowing &&
          <Prompt
            isVisible={this.state.deletePromptShowing}
            titleText="Please note"
            subtitleText={`Are you sure you would like to delete ${this.state.selectedTemplateName}?`}
            buttons={deletePromptButtons}
            onClose={() => this.setState({ deletePromptShowing: false })}
          />
        }
        <div>
          <div className={CloseAlertControls + " " + styles.templates}>
            <div className={styles.content}>
              <div className={styles.spanButtons + " " + styles.headingRow}>
                <span>{copy.myAvailabilityScreen.myAvailability.availabilityTemplateModal.title}</span>
                <button
                  className="closeAlertControls__btn -close"
                  onClick={this.props.onClose}
                >
                </button>
              </div>
              <div className={styles.horizontalRule}>
                <span className={styles.subtitleText + " " + styles.templates}>
                  {copy.myAvailabilityScreen.myAvailability.availabilityTemplateModal.description}
                </span>
              </div>
              <form className={styles.templates}>
                <fieldset className={styles.templates}>
                  <div>
                    {this.state.templateList.map((e) => {
                      return (<div key={e.TemplateId} onClick={() => this.handleTemplateClick(e)} className={styles.listItem + " " + styles.templateItem}>
                        <label htmlFor={e.TemplateId}>{e.TemplateName}</label>
                        <input
                          type="radio"
                          name="templateList"
                          key={e.TemplateId}
                          id={e.TemplateId}
                          value={e.TemplateName}
                          checked={this.state.selectedTemplate === e.TemplateId}
                        ></input>
                      </div>)
                    })}
                  </div>
                </fieldset>
              </form>
              <div className={styles.spanButtons + " " + styles.templates}>
                <Button
                  label="Delete"
                  buttonClick={this.handleDeleteClick}
                  content="Delete"
                  variant="btn_secondary"
                  styles="neutralGrey"
                  send_disable={!this.state.selectedTemplate}
                ></Button>
                <Button
                  label="Apply"
                  buttonClick={this.handleApplyClick}
                  content="Apply"
                  variant="btn_secondary"
                  styles="neutralGrey"
                  send_disable={!this.state.selectedTemplate}
                ></Button>
              </div>
              <div className={styles.spanInput}>
                <span className={styles.spacing}>{copy.myAvailabilityScreen.myAvailability.availabilityTemplateModal.newTemplate}</span>
                <input className="selectStyle" value={this.state.templateName} placeholder={copy.myAvailabilityScreen.myAvailability.availabilityTemplateModal.placeholder} onChange={(e) => this.setState({ templateName: e.target.value })}></input>
              </div>

              <div className={styles.spanButtons + " " + styles.bottomTemplates + " " + styles.templates}>
                <Button
                  label="Back"
                  buttonClick={this.props.onClose}
                  content="Back"
                  variant="btn_secondary"
                  styles="neutralGrey"
                >

                </Button>
                <Button
                  label="Save"
                  buttonClick={() => {
                    this.saveAvailabilityAsTemplate()
                  }}
                  content="Save"
                  disabled={this.state.templateList?.length >= 10}
                  variant="btn_secondary"
                  styles="neutralGrey"
                  send_disable={!this.state.templateName}
                ></Button>
              </div>

            </div>
          </div>
          <div className={DarkMask} />
        </div>
      </Wrapper>
    );
  }
}

export default withRouter(AvailabilityTemplateModal);
